export const CATEGORY_SEA = [
  {
    title: "ВСЁ",
    // type:'all',
  },

  {
    title: "МАСКИ И ОЧКИ",
    type: "mask",
  },
  {
    title: "САПБОРДЫ",
    type: "supboard",
  },

  {
    title: "ШАПКА ДЛЯ ПЛАВАНИЯ",
    type: "hat",
  },
  {
    title: "ЛАСТЫ",
    type: "flippers",
  },
  {
    title: "ВЕСЛА",
    type: "oar",
  },
  {
    title: "ПЛАВНИКИ",
    type: "fin",
  },
  {
    title: "ЖИЛЕТЫ",
    type: "vest",
  },
  {
    title: "КОМПЛЕКТУЮЩИЕ САПБОРД",
    type: "sup_accessories",
  },
  {
    title: "ГЕРМОМЕШКИ",
    type: "hermo",
  },
  {
    title: "ПЛЯЖНАЯ ОБУВЬ",
    type: "shoes",
  },
  {
    title: "МЕБЕЛЬ ДЛЯ ПЛЯЖА",
    type: "beach",
  },
];
